import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../../../context';

const TextSearchCodeMappings = ({ searchClass }) => {
    const codeMappingFilter = useSelector(state => state.daylight.codeMappingFilter);
    const dispatch = useDispatch();
    const [inputValue, setInputValue] = useState(codeMappingFilter);

    const setCodeMappingFilter = (string) => dispatch(actions.daylight.setCodeMappingFilter(string));

    useEffect(() => {
        const handler = setTimeout(() => {
            setCodeMappingFilter(inputValue);
        }, 500); // Set debounce delay here

        return () => clearTimeout(handler);
    }, [inputValue, dispatch]);

    const handleChange = (e) => {
        setInputValue(e.target.value);
    };

    return (
        <th className="col col-large">
            <input
                className={searchClass}
                type="search"
                placeholder="Filter Mappings"
                value={inputValue}
                onChange={handleChange}
            />
        </th>
    );
};

export default TextSearchCodeMappings;
